import { l } from '@ds/index'

import { BillingCurrency } from 'common/billing/constants/BillingCurrency'
import { ProductSlug } from 'common/billing/constants/ProductSlug'
import { getIsAiIncludedInPlan } from 'common/billing/entities/pro/utils/getIsAiIncludedInPlan'

import {
  createPriceBreakdownArray,
  INBOX_SEATS_FEATURE,
} from '../SubscriptionSuccessModal/features'

interface V3PlanPriceBreakdownParams {
  slug: ProductSlug
  type: keyof typeof INBOX_SEATS_FEATURE
  includedActiveContacts: number
  overagePrice: {
    amount: number
    currency: BillingCurrency
  }
  activeContacts: number
}

export const getV3PlanPriceBreakdown = ({
  slug,
  type,
  includedActiveContacts,
  overagePrice,
  activeContacts,
}: V3PlanPriceBreakdownParams) =>
  createPriceBreakdownArray({
    storedContacts: {
      value: l.makeTranslate('Not billed'),
      tooltip: l.makeTranslate(
        "Everyone who's messaged you, opted in, or been imported, kept in your Contacts tab. Our new plans don't bill for this.",
      ),
    },
    activeContacts: {
      value: l.number(includedActiveContacts),
      note: l.makeTranslate('After {amount}, pay per contact.', {
        amount: l.number(includedActiveContacts),
      }),
      tooltip: l.makeTranslate(
        'People who’ve actually interacted with you (messaged you or triggered one of your automations) during the billing period. Each active contact over your plan limit costs {overagePrice}. You engage with ~{activeContacts, plural, one {# Active contact} other {# Active contacts}}/mo.',
        {
          activeContacts,
          overagePrice: l.currency(overagePrice.amount, overagePrice.currency, 3),
        },
      ),
    },
    ai: {
      value: getIsAiIncludedInPlan(slug)
        ? l.makeTranslate('Included')
        : l.makeTranslate('Not included'),
    },
    inbox: {
      value: l.makeTranslate('Included'),
      tooltip: l.makeTranslate(
        'Work together in one Inbox, assign conversations, and manage follow-ups across channels. Includes {limit, plural, one {# Inbox seat} other {# Inbox seats}}.',
        {
          limit: INBOX_SEATS_FEATURE[type],
        },
      ),
    },
  })
